import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  PageHeader,
  PageReturn,
  PageTitle,
  ContentStatus,
  PageSubheader,
  PageActions,
  PageDescription,
} from 'next/components/ui';
import useToggle from 'next/hooks/use-toggle';
import { openExperience } from 'next/lib/builder';
import { format } from 'next/lib/date';
import { OpenInBuilderManager } from 'next/components/OpenInBuilder';
import { selectPin } from 'next/entities/pins';
import { selectUser } from 'next/entities/users';
import { PinName, PinNameWrapper } from './styled';

export function Header({
  id,
  name,
  state,
  previewUrl,
  published,
  createdAt,
  createdByName,
  updatedAt,
  updatedByName,
  renderActions,
}) {
  const [builderModalVisible, toggleBuilderModal] = useToggle();

  const handleOpenInBuilder = useCallback(() => {
    openExperience({ experience: id, url: previewUrl });
  }, [id, previewUrl]);

  return (
    <PageHeader>
      <PageDescription>
        <PageTitle>
          <PageReturn to={`/pins/${id}`} />
          <PinNameWrapper>
            <PinName title={name}>{name}</PinName>
          </PinNameWrapper>
          <ContentStatus state={state} published={published} />
        </PageTitle>
        <PageSubheader>
          Created {createdByName ? `by ${createdByName}` : ''} on{' '}
          {format(createdAt, 'MMM D, YYYY')}{' '}
          {updatedAt &&
            `| Updated ${
              updatedByName ? `by ${updatedByName}` : ''
            } on ${format(updatedAt, 'MMM D, YYYY')}`}
        </PageSubheader>
      </PageDescription>
      <PageActions>
        {renderActions?.({
          id,
          onClickOpenInBuilder: toggleBuilderModal,
          updatedAt,
          published,
        })}
      </PageActions>
      <OpenInBuilderManager
        onClose={toggleBuilderModal}
        onNavigate={handleOpenInBuilder}
        type="pins"
        visible={builderModalVisible}
      />
    </PageHeader>
  );
}

Header.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  state: PropTypes.oneOf(['DRAFT', 'PUBLISHED', 'ARCHIVED']),
  previewUrl: PropTypes.string,
  published: PropTypes.bool,
  createdAt: PropTypes.number,
  createdByName: PropTypes.string,
  updatedAt: PropTypes.number,
  updatedByName: PropTypes.string,
  renderActions: PropTypes.func,
};

const mapStateToProps = (state, { id }) => {
  const {
    published,
    state: pinState,
    updatedAt,
    updatedBy,
    createdAt,
    createdBy,
    name,
    previewUrl,
  } = selectPin(state, id) || {};
  const createdByUser = selectUser(state, createdBy);
  const updatedByUser = selectUser(state, updatedBy);

  return {
    id,
    name,
    state: pinState,
    published,
    createdAt,
    createdByName: createdByUser?.fullname,
    updatedAt,
    updatedByName: updatedByUser?.fullname,
    previewUrl,
  };
};

export default connect(mapStateToProps)(Header);
